import { CCollapse } from './CCollapse.js';

const CCollapsePlugin = {
    install: (app) => {
        app.component(CCollapse.name, CCollapse);
    },
};

export { CCollapse, CCollapsePlugin };
//# sourceMappingURL=index.js.map
